export default "__VITE_ASSET__BNydWudm__"